import React, { useState, useEffect } from "react";
import { Header, Image, Statistic, Table } from "semantic-ui-react";
import PropTypes from "prop-types";

import { getTruncatedString } from "../../../utils/utils";

const TrackListItem = ({ clickVote, track, showImages, votes, hasVoted }) => {
  const [stateVoted, setStateVoted] = useState(hasVoted);
  useEffect(() => setStateVoted(hasVoted), [hasVoted]);

  return (
    <Table.Row
      onClick={() => {
        setStateVoted(true);
        clickVote(track.uri);
      }}
    >
      {showImages &&
        track.album &&
        track.album.images &&
        track.album.images[2] && (
          <Table.Cell width={1}>
            <Image style={{ width: "48px" }} src={track.album.images[2].url} />
          </Table.Cell>
        )}
      <Table.Cell>
        <Header as="h5" style={{ color: "#E9E9E9" }}>
          <Header.Content>
            {getTruncatedString(track.name)}
            <Header.Subheader style={{ color: "grey" }}>
              {track.artists.map(({ name }) => name).join(", ")}
            </Header.Subheader>
          </Header.Content>
        </Header>
      </Table.Cell>
      <Table.Cell>
        <VoteStatistic
          votes={Math.max(...[parseInt(votes), 0].filter(Number.isInteger))}
          hasVoted={stateVoted}
        />
      </Table.Cell>
    </Table.Row>
  );
};

TrackListItem.propTypes = {
  clickVote: PropTypes.func.isRequired,
  track: PropTypes.object.isRequired,
  showImages: PropTypes.bool,
  votes: PropTypes.number,
  hasVoted: PropTypes.bool,
};

const VoteStatistic = ({ votes, hasVoted }) => (
  <Statistic
    size={"mini"}
    color="green"
    style={{
      margin: 0,
      textAlign: "right",
    }}
  >
    <Statistic.Value
      style={{
        color: hasVoted ? "gray" : "green",
        fontWeight: "bold",
      }}
    >
      {votes}
    </Statistic.Value>
  </Statistic>
);

VoteStatistic.propTypes = {
  hasVoted: PropTypes.bool.isRequired,
  votes: PropTypes.number,
};

export default TrackListItem;
